// Zaległości podatkowe
export const otherCreditsFiles = (state = [], action) => { 
    switch (action.type) {
        case 'OTHER_CREDITS_FILES_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Zaległości podatkowe itemy

export const otherCreditsItems = (state = [], action) => { 
    switch (action.type) {
        case 'OTHER_CREDITS_ITEMS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// oświadczenie, że płaci terminowo zobowiązania

export const statementCreditsPaymentCheckbox = (state = false, action) => { 
    switch (action.type) {
        case 'STATEMENT_CREDITS_PAYMENT_CHECKBOX_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// zobowiązania i należności na dzień

export const receivablesObligationsDeliveriesServicesDate = (state = false, action) => { 
    switch (action.type) {
        case 'RECEIVABLES_OBLIGATIONS_DELIVERIES_SERVICES_DATE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// kwota zobowiązań ogółem
export const obligationsTotalPrice = (state = "", action) => { 
    switch (action.type) {
        case 'OBLIGATIONS_TOTAL_PRICE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// ostateczny termin zapłaty
export const obligationsLastDatePay = (state = false, action) => { 
    switch (action.type) {
        case 'OBLIGATIONS_LAST_DATE_PAY_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// liczba wierzycieli
export const obligationsNumberCreditors = (state = "", action) => { 
    switch (action.type) {
        case 'OBLIGATIONS_NUMBER_CREDITORS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// w tym zobowiązania przeterminowane
export const obligationsOverdueLiabilities = (state = "", action) => { 
    switch (action.type) {
        case 'OBLIGATIONS_OVERDUE_LIABILITIES_CHANGE':
            return action.value;      
        default:
            return state
    }
}
// zobowiązania przeterminowane powyżej 30 dni
export const obligationsOverdueLiabilitiesOver30Days = (state = "", action) => { 
    switch (action.type) {
        case 'OBLIGATIONS_OVERDUE_LIABILITIES_OVER_30_DAYS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// kwota nalezności ogółem
export const receivablesTotalPrice = (state = "", action) => { 
    switch (action.type) {
        case 'RECEIVABLES_TOTAL_PRICE_CHANGE':
            return action.value;      
        default:
            return state
    }
}
// ostateczny termin zapłaty
export const receivablesLastDatePay = (state = false, action) => { 
    switch (action.type) {
        case 'RECEIVABLES_LAST_DATE_PAY_CHANGE':
            return action.value;      
        default:
            return state
    }
}
// liczba dłużników
export const receivablesNumberCreditors = (state = "", action) => { 
    switch (action.type) {
        case 'RECEIVABLES_NUMBER_CREDITORS_CHANGE':
            return action.value;      
        default:
            return state
    }
}
// w tym należności przeterminowane
export const receivablesOverdueLiabilities = (state = "", action) => { 
    switch (action.type) {
        case 'RECEIVABLES_OVERDUE_LIABILITIES_CHANGE':
            return action.value;      
        default:
            return state
    }
}
// zobowiązania przeterminowane powyżej 30 dni
export const receivablesOverdueLiabilitiesOver30Days = (state = "", action) => { 
    switch (action.type) {
        case 'RECEIVABLES_OVERDUE_LIABILITIES_OVER_30_DAYS_CHANGE':
            return action.value;      
        default:
            return state
    }
}
//wyjaśnienie zobowiązań i należności przeterminowanych
export const explanationReceivablesObligations = (state = "", action) => { 
    switch (action.type) {
        case 'EXPLANATION_RECEIVABLES_OBLIGATIONS':
            return action.value;      
        default:
            return state
    }
}
//wyjaśnienie straty(jeśli występowała w ostatnich 2 latach)
export const explanationLoss = (state = "", action) => { 
    switch (action.type) {
        case 'EXPLANATION_LOSS':
            return action.value;      
        default:
            return state
    }
}

//Posiadam przeterminowane tak/nie
export const expiredStatus = (state = false, action) => { 
    switch (action.type) {
        case 'EXPIRED_STATUS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// zobowiązania i należności na dzień

export const balanceDate = (state = false, action) => { 
    switch (action.type) {
        case 'BALANCE_DATE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

//wyjaśnienie straty(jeśli występowała w ostatnich 2 latach)
export const balanceObligations = (state = "", action) => { 
    switch (action.type) {
        case 'BALANCE_OBLIGATIONS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

//wyjaśnienie straty(jeśli występowała w ostatnich 2 latach)
export const balanceReceivables = (state = "", action) => { 
    switch (action.type) {
        case 'BALANCE_RECEIVABLES_CHANGE':
            return action.value;      
        default:
            return state
    }
}


export const financialDataFiles = (state = [], action) => { 
    switch (action.type) {
        case 'FINANCIAL_DATA_FILES_CHANGE':
            return action.value;      
        default:
            return state
    }
}

//Posiadam przeterminowane tak/nie
export const disclaimerReg = (state = false, action) => { 
    switch (action.type) {
        case 'DISCLAIMER_REG_CHANGE':
            return action.value;      
        default:
            return state
    }
}

//podpisany plik - url
export const signedFileUrl = (state = false, action) => { 
    switch (action.type) {
        case 'SIGNED_FILE_URL':
            return action.value;      
        default:
            return state
    }
}